module.exports = __webpack_public_path__ + "media/images/badges/atmospheric-conditions-100-3f3dec2ef4a43e40e7ef445e77496f14.svg";